// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1e1nL","col":"styles_col__JrnHJ"};